/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
import ScrollReveal from '../vendors/scroll-reveal';
import '../vendors/gsap.min';
import '../vendors/ScrollTrigger.min';

jQuery( document ).ready( function() {
	if ( jQuery( '.header-nav ul li' ).hasClass( 'menu-item-has-children' ) ) {
		// Loop through each li with mega-menu
		jQuery( '.header-nav ul li.menu-item-has-children' ).each( function() {
			// Calculate left position of mega-dropdown based on its parent li
			const parentLiPosition = jQuery( this ).position();
			const parentLiWidth = jQuery( this ).outerWidth();
			const megaMenuWidth = jQuery( this ).find( '.mega-dropdown' ).outerWidth();
			const leftPosition = parentLiPosition.left + parentLiWidth / 2 - megaMenuWidth / 2;

			// Set left position of mega-dropdown
			jQuery( this ).find( '.mega-dropdown' ).css( 'left', leftPosition + 'px' );
		} );
	}

	// Your code here
	jQuery( window ).on( 'load resize', function() {
		const $topBar_height = jQuery( '.topbar' ).outerHeight();
		const $header_height = jQuery( 'header' ).outerHeight();
		const $header_wrapper = jQuery( '.header-wrapper' ).outerHeight();
		const $wpAdminBar = jQuery( '#wpadminbar' ).outerHeight();
		const $paddingTopValue = jQuery( '.hero--home' ).css( 'padding-top' );
		const $homePaddingWithLogin = $paddingTopValue - $topBar_height - $wpAdminBar;
		const $homePaddingWithoutLogin = $paddingTopValue - $topBar_height;

		const $adminTopbar = $header_wrapper + $topBar_height;
		const $headerTopbar = $header_wrapper + $topBar_height;
		const $headerTopbarAdmin = $header_wrapper + $topBar_height + $wpAdminBar;

		// Update styles for .hero-section
		jQuery( '.hero-section' ).css( 'padding-top', $header_wrapper + 'px' );

		// Update styles for elements with classes .have-topbar and .hide-topbar
		jQuery( '.have-topbar .hero-section, .hide-topbar .hero-section' ).css( 'padding-top', $header_height + 'px' );

		jQuery( 'header' ).css( 'top', '0' );
		jQuery( '.logged-in header' ).css( 'top', $wpAdminBar + 'px' );
		jQuery( '.hide-topbar header' ).css( 'top', '-' + $topBar_height + 'px' );
		jQuery( '.nav-overlay' ).css( 'padding-top', '0' );
		// jQuery( '.nav-overlay' ).css( 'height', 'auto' );
		jQuery( '.logged-in.admin-bar  .nav-overlay' ).css( 'height', 'auto' );
		jQuery( '.have-topbar .nav-overlay' ).css( 'height', 'auto' );
		jQuery( '.have-topbar.logged-in.admin-bar .nav-overlay' ).css( 'height', 'auto' );

		if ( jQuery( window ).width() > 782 ) {
			jQuery( '.nav-overlay' ).css( 'padding-top', '0' );
			jQuery( '.hide-topbar header' ).css( 'top', '-' + $topBar_height + 'px' );
			if ( jQuery( window ).width() < 1180 ) {
				jQuery( '.nav-overlay' ).css( 'padding-top', $header_wrapper + 'px' );
				jQuery( '.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', $headerTopbar + 'px' );
				jQuery( '.have-topbar .nav-overlay' ).css( 'padding-top', $headerTopbar + 'px' );
				jQuery( '.have-topbar.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', $headerTopbarAdmin + 'px' );
			}

			jQuery( '.top-bar-cross' ).on( 'click', function() {
				jQuery( 'header' ).css( 'top', '-' + $topBar_height + 'px' );
				jQuery( '.hero-section' ).css( 'padding-top', $header_wrapper + 'px' );

				// nav overlay values
				if ( jQuery( window ).width() < 1180 ) {
					jQuery( '.hide-topbar .nav-overlay' ).css( 'padding-top', ( $headerTopbar - $topBar_height ) + 'px' );
					jQuery( '.hide-topbar.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', ( $headerTopbarAdmin - $topBar_height ) + 'px' );
				}
			} );
			if ( jQuery( 'body' ).hasClass( 'logged-in admin-bar' ) ) {
				const $loggedInHeight = $topBar_height - 31;
				jQuery( '.top-bar-cross' ).on( 'click', function() {
					jQuery( 'header' ).css( 'top', '-' + $loggedInHeight + 'px' );
				} );
			}
		}

		if ( jQuery( window ).width() < 783 ) {
			const calculatedWidth = `calc(100vh - ${ $header_wrapper }px)`;
			const calculatedWidthloggedin = `calc(100vh - ${ $header_wrapper + $wpAdminBar }px)`;
			const calculatedWidthhavetopbar = `calc(100vh - ${ $header_wrapper + $topBar_height }px)`;
			const calculatedWidthloggedtopbar = `calc(100vh - ${ $header_wrapper + $topBar_height + $wpAdminBar }px)`;

			// jQuery( '.nav-overlay' ).css( 'height', calculatedWidth );
			// jQuery( '.logged-in.admin-bar  .nav-overlay' ).css( 'height', calculatedWidthloggedin );

			// jQuery( '.have-topbar .nav-overlay' ).css( 'height', calculatedWidthhavetopbar );
			// jQuery( '.have-topbar.logged-in.admin-bar .nav-overlay' ).css( 'height', calculatedWidthloggedtopbar );

			jQuery( '.top-bar-cross' ).on( 'click', function() {
				jQuery( 'header' ).css( 'top', '-' + $topBar_height + 'px' );
				jQuery( '.hero-section' ).css( 'padding-top', $header_wrapper + 'px' );

				// nav overlay values
				jQuery( '.hide-topbar .nav-overlay' ).css( 'padding-top', ( $headerTopbar - $topBar_height ) + 'px' );
				jQuery( '.hide-topbar.logged-in.admin-bar .nav-overlay' ).css( 'padding-top', ( $headerTopbarAdmin - $topBar_height ) + 'px' );
			} );

			if ( jQuery( 'body' ).hasClass( 'logged-in admin-bar' ) ) {
				const $loggedInHeight = $topBar_height - 45;
				jQuery( '.top-bar-cross' ).on( 'click', function() {
					jQuery( 'header' ).css( 'top', '-' + $loggedInHeight + 'px' );
				} );
			}
		}
	} );

	function positionMegaDropdowns() {
		if ( jQuery( '.header-nav ul li' ).hasClass( 'menu-item-has-children' ) ) {
			// Loop through each li with mega-menu
			jQuery( '.header-nav ul li.menu-item-has-children' ).each( function() {
				// Calculate left position of mega-dropdown based on its parent li
				const parentLiPosition = jQuery( this ).position();
				const parentLiWidth = jQuery( this ).outerWidth();
				const megaMenuWidth = jQuery( this ).find( '.mega-dropdown' ).outerWidth();
				const leftPosition = parentLiPosition.left + parentLiWidth / 2 - megaMenuWidth / 2;

				// Set left position of mega-dropdown
				jQuery( this ).find( '.mega-dropdown' ).css( 'left', leftPosition + 'px' );
			} );
		}
	}

	jQuery( document ).ready( function() {
		// Call the function on document ready
		positionMegaDropdowns();

		// Call the function on window resize
		jQuery( window ).resize( function() {
			positionMegaDropdowns();
		} );
	} );
} );

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header' ).addClass( 'shrink' );
		if ( jQuery( 'body' ).hasClass( 'with-white-header' ) ) {
			jQuery( 'header' ).removeClass( 'white-header' );
		}
	} else {
		jQuery( 'header' ).removeClass( 'shrink' );
		if ( jQuery( 'body' ).hasClass( 'with-white-header' ) ) {
			jQuery( 'header' ).addClass( 'white-header' );
		}
	}
} );

jQuery( document ).ready( function() {
	if ( jQuery( 'mark' ).length > 0 ) {
		gsap.registerPlugin( ScrollTrigger );
		const leadParaItems = document.querySelectorAll( 'mark' );
		leadParaItems.forEach( ( item, index ) => {
			gsap.to( item, {
				scrollTrigger: {
					trigger: item,
					start: 'top 50% top',
					endTrigger: item,
					end: 'bottom center',
					scrub: true,
					pin: false,
					onEnter: () => item.classList.add( 'draw-image' ),
					// onLeaveBack: () => item.classList.remove( 'draw-image' ),
				},
				duration: 1,
			} );
		} );
	}
	if ( jQuery( '.hero-section mark' ).length > 0 ) {
		gsap.registerPlugin( ScrollTrigger );
		const leadParaItems = document.querySelectorAll( '.hero-section mark' );
		leadParaItems.forEach( ( item, index ) => {
			gsap.to( item, {
				scrollTrigger: {
					trigger: item,
					start: 'top 100% top',
					endTrigger: item,
					end: 'bottom center',
					scrub: true,
					pin: false,
					onEnter: () => item.classList.add( 'draw-image' ),
					// onLeaveBack: () => item.classList.remove( 'draw-image' ),
				},
				duration: 1,
			} );
		} );
	}
	if ( jQuery( '.collage-image__image' ).length > 0 ) {
		gsap.registerPlugin( ScrollTrigger );
		const leadParaItems = document.querySelectorAll( '.collage-image__image' );
		leadParaItems.forEach( ( item, index ) => {
			gsap.to( item, {
				scrollTrigger: {
					trigger: item,
					start: 'top 50% top',
					endTrigger: item,
					end: 'bottom center',
					scrub: true,
					pin: false,
					onEnter: () => item.classList.add( 'animating' ),
					// onLeaveBack: () => item.classList.remove( 'animating' ),
				},
				duration: 1,
			} );
		} );
	}
	if ( jQuery( '.animate-graphic' ).length > 0 ) {
		gsap.registerPlugin( ScrollTrigger );
		const leadParaItems = document.querySelectorAll( '.animate-graphic' );
		leadParaItems.forEach( ( item, index ) => {
			gsap.to( item, {
				scrollTrigger: {
					trigger: item,
					start: 'top 50% top',
					endTrigger: item,
					end: 'bottom center',
					scrub: true,
					pin: false,
					onEnter: () => item.classList.add( 'animating' ),
					// onLeaveBack: () => item.classList.remove( 'animating' ),
				},
				duration: 1,
			} );
		} );
	}
	if ( jQuery( '.draw-svg' ).length > 0 ) {
		gsap.registerPlugin( ScrollTrigger );
		const leadParaItems = document.querySelectorAll( '.draw-svg' );
		leadParaItems.forEach( ( item, index ) => {
			gsap.to( item, {
				scrollTrigger: {
					trigger: item,
					start: 'top 80% top',
					endTrigger: item,
					end: 'bottom center',
					scrub: true,
					pin: false,
					onEnter: () => item.classList.add( 'animating' ),
					// onLeaveBack: () => item.classList.remove( 'animating' ),
				},
				duration: 1,
			} );
		} );
	}

	if ( jQuery( 'body' ).hasClass( 'single single-event' ) ) {
		// Add the class to the HTML element
		jQuery( 'html' ).addClass( 'scroll-behavior-normal' );
	}

	if ( jQuery( 'body' ).hasClass( 'page-template-template-events-list' ) ) {
		// Add the class to the HTML element
		jQuery( 'html' ).addClass( 'scroll-behavior-normal' );
	}

	//Add View more Functionality for View More
	const itemsPerPage = 3;
	const $eventitems = jQuery( '.event-posts' );
	let visibleItems = itemsPerPage;
	$eventitems.slice( 0, visibleItems ).show();
	jQuery( '#past-event-view span' ).click( function() {
		visibleItems += itemsPerPage;
		if ( visibleItems < $eventitems.length ) {
			$eventitems.slice( 0, visibleItems ).show();
		} else {
			$eventitems.show();
			jQuery( '#past-event-view' ).hide();
		}
	} );
	if ( $eventitems.length === 3 || $eventitems.length === 1 ) {
		jQuery( '#past-event-view' ).hide();
	}
	//End Add View more Functionality for  View More

	/**
	 * Toggle menu for mobile
	 */
	jQuery( document ).ready( function( $ ) {
		jQuery( '#load-file-button' ).click( function() {
			// File ko load karne ke liye window.location ka istemal karen
			window.location.href = 'your-file.php';
		} );
	} );

	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );
	jQuery( '.sub-menu a' ).focus( function() {
		jQuery( this ).parents( '.sub-menu' ).addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).parents( '.sub-menu' ).removeClass( 'focused' );
	} );

	jQuery( '.menu-btn' ).click( function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	jQuery( '.header-nav .submenu-icon' ).on( 'click', function( event ) {
		event.stopPropagation(); // Stop the event from propagating to inner elements
		const link = jQuery( this );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );

		if ( ! linkStatus ) {
			// Close all other open submenus
			jQuery( '.header-nav .submenu-icon' ).not( link ).closest( 'li' ).removeClass( 'active' );
			jQuery( '.header-nav .submenu-icon' ).not( link ).closest( 'li' ).children( 'ul, .mega-dropdown' ).slideUp();

			// Open the clicked submenu
			closestLi.children( 'ul, .mega-dropdown' ).slideDown();
			closestLi.addClass( 'active' );
		} else {
			// Close the clicked submenu
			closestLi.children( 'ul, .mega-dropdown' ).slideUp();
			closestLi.removeClass( 'active' );
		}
	} );

	jQuery( '.search-button' ).on( 'click', function( e ) {
		jQuery( '.header-search' ).addClass( 'show' );
	} );

	jQuery( '.search-close' ).on( 'click', function() {
		jQuery( '.header-search' ).removeClass( 'show' );
	} );

	jQuery( '.video__inner--area, .image-with-text-popup, .media-popup, .video-popup' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		preloader: false,
		fixedContentPos: false,
	} );

	jQuery( document ).on( 'click', function( e ) {
		if ( ! jQuery( e.target ).closest( '.header-popup' ).length ) {
			jQuery( '.header-popup' ).removeClass( 'show-popup' );
		}
	} );

	jQuery( '.popup-btn' ).on( 'click focus', function( e ) {
		e.stopPropagation();
		jQuery( '.header-popup' ).addClass( 'show-popup' );
	} ).on( 'focusout', function() {
		jQuery( '.header-popup' ).removeClass( 'show-popup' );
	} );

	jQuery( '.icon-row a, .popup-box a, .header-popup__title' ).on( 'focus ', function() {
		jQuery( '.header-popup' ).addClass( 'show-popup' );
	} ).on( 'focusout', function() {
		jQuery( '.header-popup' ).removeClass( 'show-popup' );
	} );
	jQuery( '.header-popup-cross' ).on( 'click ', function() {
		jQuery( '.header-popup' ).removeClass( 'show-popup' );
	} );

	jQuery( '.search-button' ).on( 'click', function( e ) {
		jQuery( '.header-search' ).addClass( 'show' );
	} );

	jQuery( '.search-close' ).on( 'click', function() {
		jQuery( '.header-search' ).removeClass( 'show' );
	} );

	/**
	 *
	 * * Exit Model Popup
	 *
	 *
	 */

	jQuery( '.exit-close-model,.exit-cross' ).on( 'click', function() {
		jQuery( '.exit-popup' ).removeClass( 'show-model' );
	} );

	// quote-slider

	jQuery( '.quote__content-outer' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		asNavFor: '.quote__img--outer',
	} );

	// Initialize the image slider
	jQuery( '.quote__img--outer' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.quote__content-outer',
		dots: false,
		arrows: false,
		fade: true,
		infinite: false,
		focusOnSelect: true,
	} );

	/**
	 *
	 * * Event slider
	 *
	 *
	 */

	if ( jQuery( window ).width() > 1003 ) {
		const totalSlides = jQuery( '.js-event-slider .owl-item' ).length;
		const mouseDragEnabled = totalSlides > 2; // Check if there are more than 2 slides

		jQuery( '.js-event-slider' ).owlCarousel( {
			nav: true,
			items: 2,
			margin: 20,
			dots: false,
			loop: false,
			mouseDrag: mouseDragEnabled, // Enable/disable mouse drag based on the number of slides
		} );
	}

	jQuery( '.event-slider' ).owlCarousel( {
		nav: true,
		items: 1,
		dots: false,
		autoWidth: true,
		// afterInit: setWidth(),
	} );

	/**
	 *
	 * * Host slider
	 *
	 *
	 */

	jQuery( document ).mouseup( function( e ) {
		const container = jQuery( '.host-popup' );
		// if the target of the click isn't the container nor a descendant of the container
		if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
			jQuery( '.host-popup' ).removeClass( 'show' );
			jQuery( 'body' ).removeClass( 'show' );
			// jQuery( 'html' ).css( 'overflow-y', 'scroll' );
			// jQuery( 'html' ).css( 'margin-right', '0' );
		}
	} );
	jQuery.noConflict();

	jQuery( '.host-member-image a, a.read-more ' ).on( 'click', function() {
		jQuery( '.host-popup' ).removeClass( 'show' );
		jQuery( 'body' ).removeClass( 'show' );
		const id = jQuery( this ).attr( 'href' );
		jQuery( id ).addClass( 'show' );
		jQuery( 'body' ).addClass( 'show' );
		jQuery( 'html' ).addClass( 'show-sidebar' );
		// jQuery( 'html' ).css( 'overflow-y', 'hidden' );
		// jQuery( 'html' ).css( 'margin-right', '16px' );
	} );

	jQuery( '.popup-close' ).on( 'click', function() {
		jQuery( '.host-popup' ).removeClass( 'show' );
		jQuery( 'body' ).removeClass( 'show' );
		jQuery( 'html' ).removeClass( 'show-sidebar' );
		// jQuery( 'html' ).css( 'overflow-y', 'scroll' );
		// jQuery( 'html' ).css( 'margin-right', '0' );
	} );
	jQuery.noConflict();

	// stat

	jQuery(
		( function( jQuery, win ) {
			jQuery.fn.inViewport = function( cb ) {
				return this.each( function( i, el ) {
					function visPx() {
						const H = jQuery( this ).height(),
							r = el.getBoundingClientRect(),
							t = r.top,
							b = r.bottom;
						return cb.call( el, Math.max( 0, t > 0 ? H - t : b < H ? b : H ) );
					}
					visPx();
					jQuery( win ).on( 'load scroll', visPx );
				} );
			};
		} )( jQuery, window )
	);

	jQuery( function( jQuery ) {
	    jQuery( '.count' ).inViewport( function( px ) {
	        if ( px > 0 && ! this.initNumAnim ) {
	            this.initNumAnim = true;

	            // Parse the original value as a float
	            const originalValue = parseFloat( jQuery( this ).text() );

	            // Choose a start value based on your requirements
	            const startValue = Math.max( originalValue - 10, 0 );

	            // Set the Counter property with the start value
	            jQuery( this ).prop( 'Counter', startValue ).animate( {
	                Counter: originalValue,
	            }, {
	                duration: 2000,
	                easing: 'swing',
	                step( now ) {
	                    // Update the text content with the current value
	                    const formattedValue = now % 1 === 0 ? now.toFixed( 0 ) : now.toFixed( 1 );
	                    jQuery( this ).text( formattedValue.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,' ) );
	                },
	            } );
	        }
	    } );
	} );

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.select-dropdown__button' ).on( 'click', function() {
			const dropdown = jQuery( this ).closest( '.select-dropdown' );
			dropdown.find( '.select-dropdown__button' ).toggleClass( 'is-button-opened' );
			dropdown.find( '.select-dropdown__list' ).toggleClass( 'is-active-dropdown' );
		} );
		jQuery( '.dropdown-list-title' ).on( 'click', function() {
			const dropdown = jQuery( this ).closest( '.select-dropdown' );
			dropdown.find( '.select-dropdown__button' ).toggleClass( 'is-button-opened' );
			dropdown.find( '.select-dropdown__list' ).toggleClass( 'is-active-dropdown' );
		} );
		jQuery( '.dropdown-list-title' ).on( 'click', function() {
			const ratioText = 'Ratio';
			const itemValue = jQuery( this ).find( 'span,a.dropdown__link ' ).data( ratioText );
			jQuery( this ).parents( '.select-dropdown' ).find( '.select-dropdown__button' ).text( jQuery( this ).find( 'span,a.dropdown__link ' ).text() ).parents().attr( 'data-value', itemValue );
		} );
	}

	jQuery( '.have-mega-menu' ).each( function() {
		// Check if the element has exactly two children with class mega-dropdown__text--inner
		if ( jQuery( this ).find( '.mega-dropdown__text--inner' ).length === 2 ) {
			// If it has two children, add the class 'large' to the element with class have-mega-menu
			jQuery( this ).addClass( 'large' );
		}
	} );

	jQuery( '.block-acf-theme-video' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'no-overflow' );
	jQuery( '.block-acf-image-gallery' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'no-overflow' );

	/**
	 * Scroll Reveal
	 *
	 * @param target
	 * @param onEnter
	 * @param onExit
	 */

	const liClicked = false;
	const navID = '.sticky-nav'; // Update the navigation selector

	jQuery( window ).scroll( function() {
		const y = jQuery( this ).scrollTop();
		jQuery( navID + ' ul li a' ).each( function() {
			const href = jQuery( this ).attr( 'href' );
			const targetElement = jQuery( href );
			if ( targetElement.length > 0 ) {
				const viewPort = targetElement.offset().top - 260;
				if ( y >= viewPort ) {
					if ( ! liClicked ) {
						jQuery( navID + ' ul li' ).removeClass( 'active' );
						jQuery( this ).parent().addClass( 'active' );
					}
				}
			}
		} );
	} );
	jQuery( window ).load( function() {
		setTimeout( () => {
			const ids = window.location.hash.split( '#' ).join( ',#' ).slice( 1 );
			if ( ids !== '' ) {
				const targetElement = jQuery( ids );
				if ( targetElement.length > 0 ) {
					console.log( targetElement, targetElement.offset().top - 130 );
					jQuery( 'html, body' ).animate(
						{
							scrollTop: targetElement.offset().top - 130,
						},
						500
					);
				}
			}
		}, 10 );
	} );

	jQuery( navID + ' ul li a' ).click( function( e ) {
		e.preventDefault();
		const href = jQuery( this ).attr( 'href' );
		const targetElement = jQuery( href );
		if ( targetElement.length > 0 ) {
			jQuery( 'html, body' ).animate(
				{
					scrollTop: targetElement.offset().top - 130,
				},
				500
			);
			jQuery( navID + ' ul li' ).removeClass( 'active' );
			jQuery( this ).parent().addClass( 'active' );
		}
	} );

	jQuery( '.hero--event-list .hero-button a' ).click( function( e ) {
		e.preventDefault();
		const href = jQuery( this ).attr( 'href' );
		const targetElement = jQuery( href );
		if ( targetElement.length > 0 ) {
			jQuery( 'html, body' ).animate(
				{
					scrollTop: targetElement.offset().top - 130,
				},
				500
			);
		}
	} );

	// click functionality for same page button class to category button
	// Get all elements with class "link-arrow"
	const linkArrows = document.querySelectorAll( '.page-id-398 .icon-grid__btn .link-arrow' );

	// Attach click event listener to each link
	linkArrows.forEach( ( link ) => {
		link.addEventListener( 'click', function( event ) {
			event.preventDefault(); // Prevent the default behavior of the link

			const targetHash = this.getAttribute( 'href' ); // Get the href attribute value (which is the hash)
			// Find the corresponding li element with the same hash
			const targetLi = document.querySelector( `li[data-category="${ targetHash.slice( 1 ) }"]` );

			// If the corresponding li element is found
			if ( targetLi ) {
				targetLi.scrollIntoView( { behavior: 'smooth' } ); // Scroll to the element smoothly
				targetLi.querySelector( 'a' ).click(); // Trigger a click event on the inner a tag
			}
		} );
	} );

	// stats owl carousel
	if ( jQuery( window ).width() < 1003 ) {
		jQuery( '.page-template-template-services  .stats-counter, .page-template-template-get-involved  .stats-counter' ).slick( {
			slidesToShow: 2,
			infinite: false,
			slidesToScroll: 1,
			arrows: true,
			cssEase: 'ease-in-out',
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1003,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						fade: true,
					},
				},
			],
		} );
	}
} );

